// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Data sources list.
  The row leads with its HTTP verb, the way an API client does, so the table can be
  scanned by method before it is read by name. Everything else stays quiet.
*/
:host {
  --ds-ink: #2b3445;
  --ds-ink-soft: #74788d;
  --ds-line: #ebedf2;
  --ds-brand: #008fc7;
  --ds-mono: "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace;
}

/* ---------- head ---------- */

.ds-count {
  font-family: var(--ds-mono);
  font-size: 0.78rem;
  color: var(--ds-ink-soft);
}

/* ---------- search ---------- */

.ds-toolbar {
  margin-bottom: 1.5rem;
}

.ds-search {
  position: relative;
  max-width: 26rem;
}

.ds-search__icon {
  position: absolute;
  top: 50%;
  left: 0.9rem;
  transform: translateY(-50%);
  font-size: 0.85rem;
  color: var(--ds-ink-soft);
  pointer-events: none;
}

.ds-search__input {
  padding-left: 2.4rem;
  padding-right: 2.2rem;
}

.ds-search__input:focus {
  border-color: var(--ds-brand);
  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.12);
}

.ds-search__clear {
  position: absolute;
  top: 50%;
  right: 0.6rem;
  transform: translateY(-50%);
  padding: 0.25rem 0.4rem;
  border: 0;
  border-radius: 50%;
  background: none;
  font-size: 0.8rem;
  color: var(--ds-ink-soft);
  cursor: pointer;
}

.ds-search__clear:hover,
.ds-search__clear:focus-visible {
  color: var(--ds-ink);
  background: #f0f2f5;
}

/* ---------- loading / empty / error ---------- */

.ds-state {
  padding: 3.5rem 1rem;
  text-align: center;
  color: var(--ds-ink-soft);
}

.ds-state__spinner {
  margin-right: 0.5rem;
  color: var(--ds-brand);
}

.ds-state__title {
  margin-bottom: 0.35rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--ds-ink);
}

.ds-state__text {
  margin-bottom: 1.25rem;
}

.ds-state--error .ds-state__title {
  color: #8f1717;
}

/* ---------- table ---------- */

.ds-table {
  border-collapse: separate;
}

.ds-table th.mat-header-cell {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ds-ink-soft);
  border-bottom: 1px solid var(--ds-line);
  white-space: nowrap;
}

.ds-table td.mat-cell {
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid var(--ds-line);
  vertical-align: middle;
}

.ds-table tr.mat-row:hover {
  background: #f7f9fb;
}

.ds-col-method {
  width: 6.5rem;
}

.ds-col-auth {
  width: 7rem;
}

.ds-col-id {
  width: 5rem;
}

.ds-col-action {
  width: 10rem;
  text-align: right;
}

/* ---------- method tag ---------- */

.ds-method {
  display: inline-block;
  min-width: 4.4rem;
  padding: 0.2rem 0.45rem;
  border-radius: 3px;
  font-family: var(--ds-mono);
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--ds-ink-soft);
  background: #f0f2f5;
}

.ds-method--get {
  color: #0f766e;
  background: #e4f1ef;
}

.ds-method--post {
  color: #854d0e;
  background: #fbf1e0;
}

.ds-method--put {
  color: #6d28d9;
  background: #efeafb;
}

.ds-method--delete {
  color: #b91c1c;
  background: #fbe9e9;
}

.ds-method--patch {
  color: #155e75;
  background: #e2f0f5;
}

/* ---------- name, url, auth, id ---------- */

.ds-name {
  display: block;
  font-weight: 500;
  color: var(--ds-ink);
}

.ds-description {
  display: block;
  margin-top: 0.15rem;
  font-size: 0.78rem;
  color: var(--ds-ink-soft);
  max-width: 28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ds-url {
  display: inline-block;
  max-width: 32rem;
  font-family: var(--ds-mono);
  font-size: 0.8rem;
  color: var(--ds-ink);
  word-break: break-all;
}

.ds-url ::ng-deep .ds-url__token {
  color: var(--ds-brand);
}

.ds-auth {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.15rem 0.5rem;
  border: 1px solid var(--ds-line);
  border-radius: 999px;
  font-size: 0.72rem;
  color: var(--ds-ink-soft);
}

.ds-auth--secured {
  border-color: #d5e7ef;
  color: #0b6d95;
  background: #f0f8fb;
}

.ds-auth i {
  font-size: 0.62rem;
}

.ds-id {
  padding: 0.1rem 0.35rem;
  border: 0;
  border-radius: 3px;
  background: none;
  font-family: var(--ds-mono);
  font-size: 0.78rem;
  color: var(--ds-ink-soft);
  cursor: pointer;
}

.ds-id:hover,
.ds-id:focus-visible {
  color: var(--ds-brand);
  background: #f0f2f5;
}

/* ---------- actions ---------- */

.ds-actions {
  text-align: right;
  white-space: nowrap;
}

.ds-actions .btn[disabled] {
  opacity: 0.5;
  cursor: default;
}

/* ---------- responsive ---------- */

@media (max-width: 1024px) {
  .ds-table-wrapper {
    overflow-x: auto;
  }

  .ds-url,
  .ds-description {
    max-width: 18rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fa-spin {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/views/data-source/data-source.component.css"],"names":[],"mappings":"AAAA;;;;CAIC;AACD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA,+BAA+B;;AAE/B;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,kDAAkD;;AAElD;EACE,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,gCAAgC;;AAEhC;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,8CAA8C;;AAE9C;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,qCAAqC;;AAErC;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["/*\n  Data sources list.\n  The row leads with its HTTP verb, the way an API client does, so the table can be\n  scanned by method before it is read by name. Everything else stays quiet.\n*/\n:host {\n  --ds-ink: #2b3445;\n  --ds-ink-soft: #74788d;\n  --ds-line: #ebedf2;\n  --ds-brand: #008fc7;\n  --ds-mono: \"SFMono-Regular\", Menlo, Consolas, \"Liberation Mono\", monospace;\n}\n\n/* ---------- head ---------- */\n\n.ds-count {\n  font-family: var(--ds-mono);\n  font-size: 0.78rem;\n  color: var(--ds-ink-soft);\n}\n\n/* ---------- search ---------- */\n\n.ds-toolbar {\n  margin-bottom: 1.5rem;\n}\n\n.ds-search {\n  position: relative;\n  max-width: 26rem;\n}\n\n.ds-search__icon {\n  position: absolute;\n  top: 50%;\n  left: 0.9rem;\n  transform: translateY(-50%);\n  font-size: 0.85rem;\n  color: var(--ds-ink-soft);\n  pointer-events: none;\n}\n\n.ds-search__input {\n  padding-left: 2.4rem;\n  padding-right: 2.2rem;\n}\n\n.ds-search__input:focus {\n  border-color: var(--ds-brand);\n  box-shadow: 0 0 0 3px rgba(0, 143, 199, 0.12);\n}\n\n.ds-search__clear {\n  position: absolute;\n  top: 50%;\n  right: 0.6rem;\n  transform: translateY(-50%);\n  padding: 0.25rem 0.4rem;\n  border: 0;\n  border-radius: 50%;\n  background: none;\n  font-size: 0.8rem;\n  color: var(--ds-ink-soft);\n  cursor: pointer;\n}\n\n.ds-search__clear:hover,\n.ds-search__clear:focus-visible {\n  color: var(--ds-ink);\n  background: #f0f2f5;\n}\n\n/* ---------- loading / empty / error ---------- */\n\n.ds-state {\n  padding: 3.5rem 1rem;\n  text-align: center;\n  color: var(--ds-ink-soft);\n}\n\n.ds-state__spinner {\n  margin-right: 0.5rem;\n  color: var(--ds-brand);\n}\n\n.ds-state__title {\n  margin-bottom: 0.35rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--ds-ink);\n}\n\n.ds-state__text {\n  margin-bottom: 1.25rem;\n}\n\n.ds-state--error .ds-state__title {\n  color: #8f1717;\n}\n\n/* ---------- table ---------- */\n\n.ds-table {\n  border-collapse: separate;\n}\n\n.ds-table th.mat-header-cell {\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ds-ink-soft);\n  border-bottom: 1px solid var(--ds-line);\n  white-space: nowrap;\n}\n\n.ds-table td.mat-cell {\n  padding-top: 0.85rem;\n  padding-bottom: 0.85rem;\n  border-bottom: 1px solid var(--ds-line);\n  vertical-align: middle;\n}\n\n.ds-table tr.mat-row:hover {\n  background: #f7f9fb;\n}\n\n.ds-col-method {\n  width: 6.5rem;\n}\n\n.ds-col-auth {\n  width: 7rem;\n}\n\n.ds-col-id {\n  width: 5rem;\n}\n\n.ds-col-action {\n  width: 10rem;\n  text-align: right;\n}\n\n/* ---------- method tag ---------- */\n\n.ds-method {\n  display: inline-block;\n  min-width: 4.4rem;\n  padding: 0.2rem 0.45rem;\n  border-radius: 3px;\n  font-family: var(--ds-mono);\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-align: center;\n  color: var(--ds-ink-soft);\n  background: #f0f2f5;\n}\n\n.ds-method--get {\n  color: #0f766e;\n  background: #e4f1ef;\n}\n\n.ds-method--post {\n  color: #854d0e;\n  background: #fbf1e0;\n}\n\n.ds-method--put {\n  color: #6d28d9;\n  background: #efeafb;\n}\n\n.ds-method--delete {\n  color: #b91c1c;\n  background: #fbe9e9;\n}\n\n.ds-method--patch {\n  color: #155e75;\n  background: #e2f0f5;\n}\n\n/* ---------- name, url, auth, id ---------- */\n\n.ds-name {\n  display: block;\n  font-weight: 500;\n  color: var(--ds-ink);\n}\n\n.ds-description {\n  display: block;\n  margin-top: 0.15rem;\n  font-size: 0.78rem;\n  color: var(--ds-ink-soft);\n  max-width: 28rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ds-url {\n  display: inline-block;\n  max-width: 32rem;\n  font-family: var(--ds-mono);\n  font-size: 0.8rem;\n  color: var(--ds-ink);\n  word-break: break-all;\n}\n\n.ds-url ::ng-deep .ds-url__token {\n  color: var(--ds-brand);\n}\n\n.ds-auth {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.15rem 0.5rem;\n  border: 1px solid var(--ds-line);\n  border-radius: 999px;\n  font-size: 0.72rem;\n  color: var(--ds-ink-soft);\n}\n\n.ds-auth--secured {\n  border-color: #d5e7ef;\n  color: #0b6d95;\n  background: #f0f8fb;\n}\n\n.ds-auth i {\n  font-size: 0.62rem;\n}\n\n.ds-id {\n  padding: 0.1rem 0.35rem;\n  border: 0;\n  border-radius: 3px;\n  background: none;\n  font-family: var(--ds-mono);\n  font-size: 0.78rem;\n  color: var(--ds-ink-soft);\n  cursor: pointer;\n}\n\n.ds-id:hover,\n.ds-id:focus-visible {\n  color: var(--ds-brand);\n  background: #f0f2f5;\n}\n\n/* ---------- actions ---------- */\n\n.ds-actions {\n  text-align: right;\n  white-space: nowrap;\n}\n\n.ds-actions .btn[disabled] {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* ---------- responsive ---------- */\n\n@media (max-width: 1024px) {\n  .ds-table-wrapper {\n    overflow-x: auto;\n  }\n\n  .ds-url,\n  .ds-description {\n    max-width: 18rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-spin {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
